import { useWorkspaceCategories } from "@api/category.api";
import { useWorkspaceDetails } from "@api/workspace.api";
import {
    useEntitiesContexts,
    useEntitiesContextsQueryState,
} from "@hooks/useEntitiesContexts";
import { useIsGlFirst } from "@hooks/useIsGlFirst";
import { useScope } from "@state/scopeContext.lib";
import { TRANSFER_REVIEW_VIEW_ID } from "./views/TransferReviewView";
import { useTransactionsPageDefaultViewId } from "./views/useTransactionsPageDefaultView";

export function useTransactionsPageReady() {
    const { workspaceId } = useScope();
    const entitiesContexts = useEntitiesContexts();
    const entitiesContextsQueryState = useEntitiesContextsQueryState();
    const { isError: hasWorkspaceError } = useWorkspaceDetails(workspaceId);
    const { enabled: isGlFirst, initializing: isGlFirstInitializing } =
        useIsGlFirst();
    const defaultViewId = useTransactionsPageDefaultViewId();
    const { isPending: isCategoriesPending } = useWorkspaceCategories();

    const isWaitingForCategories =
        defaultViewId === TRANSFER_REVIEW_VIEW_ID &&
        !isGlFirst &&
        isCategoriesPending;

    return (
        entitiesContexts !== undefined &&
        entitiesContextsQueryState?.status === "success" &&
        (!isGlFirstInitializing || hasWorkspaceError) &&
        !isWaitingForCategories
    );
}
